import { formatCurrency } from "utils/formatCurrency";
import { formatDateWithSuffix, getFinancialYearStart } from "utils/formatDate";
import { getIcon } from "utils/iconsConfig";
import LoadingSmallCard from "../Skeleton/LoadingSmallCard";
import TransactionSmallCard from "../Skeleton/TransactionSmallCard";
import Tooltip from "../Tooltip";

const ClientInnerCard = ({ data, type, selectedCard, setSelectedCard, isFetching }) => {
  const transactionCardContentStyle = {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    alignItems: "center",
  };

  const transactionGroupStyle = {
    padding: "12px 16px",
    border: "1px solid black",
    backgroundColor: "#141414",
    width: "398px",
    borderRadius: "10px",
  };

  const renderContent = () => {
    switch (type) {
      case "dues":
        return (
          <>
            {!data?.items?.length && <TransactionSmallCard count={10} />}
            {data?.items?.map((item, index) => {
              const isPositive = item.Balance <= item["Unfix Current Amount"];  
              const balanceColor = isPositive ? "#50C878" : "#E77B7B";

              return (
                <div
                  key={index}
                  style={{
                    ...transactionGroupStyle,
                    border: selectedCard?.TransactionNo === item.TransactionNo ? "1px solid #fff" : transactionGroupStyle.border,
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedCard(item)}
                >
                  {/* ROW 1: TransactionNo ............. BookName */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <div style={{ fontSize: "15px", fontWeight: 400, color: "#CCCCCC", fontFamily: "Karla" }}>{item.TransactionNo}</div>
                    <div style={{ fontSize: "14px", fontWeight: 500, color: "#FCFAFA", fontFamily: "Poppins", whiteSpace: "nowrap" }}>{item.BookName}</div>
                  </div>

                  {/* ROW 2: 📋 TransactionDate ........ ₹ BillAmount (white) */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <div style={{ fontSize: "12px", color: "#CCCCCC", fontFamily: "Poppins", fontWeight: 400, display: "flex", gap: "6px", alignItems: "center" }}>
                      {getIcon("Blue_Bill_Icon")} {formatDateWithSuffix(item.TransactionDate)}
                    </div>
                    <div style={{ fontSize: "14px", fontWeight: 600, color: "#FCFAFA", fontFamily: "Poppins", whiteSpace: "nowrap" }}>{formatCurrency(item.BillAmount ?? item.Balance)}</div>
                  </div>

                  {/* ROW 3: 🕐 DueDate ... ₹ Balance (green/red) OR days badge */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <div style={{ fontSize: "12px", color: "#CCCCCC", fontFamily: "Poppins", fontWeight: 400, display: "flex", gap: "6px", alignItems: "center" }}>
                      {getIcon("Due_Date_Icon")} {formatDateWithSuffix(item.DueDate)}
                    </div>
                    {item["Unfix Current Amount"] != null ? (
                      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <span style={{ fontSize: "14px", fontWeight: 600, color: balanceColor, fontFamily: "Poppins", whiteSpace: "nowrap" }}>{formatCurrency(item["Unfix Current Amount"])}</span>
                      </div>
                    ) : (
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: item?.IsDue ? "#E77B7B" : "#fff",
                          fontFamily: "Poppins",
                          display: "flex",
                          gap: "5px",
                          backgroundColor: item?.IsDue ? "#E77B7B0D" : "#0D0D0D",
                          padding: "3px 8px",
                          alignItems: "center",
                          borderRadius: "5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.IsDue ? getIcon("Due_Date_Days_Icon") : getIcon("Due_Date_Days_White")} {item.TotalDays} days
                      </div>
                    )}
                  </div>

                  {/* ROW 4: only show when unfix values exist */}
                  {(item["Unfix Current Amount"] != null || item["Unfix Weight"] != null) && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: item?.IsDue ? "#E77B7B" : "#fff",
                          fontFamily: "Poppins",
                          display: "flex",
                          gap: "5px",
                          backgroundColor: item?.IsDue ? "#E77B7B0D" : "#0D0D0D",
                          padding: "3px 8px",
                          alignItems: "center",
                          borderRadius: "5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.IsDue ? getIcon("Due_Date_Days_Icon") : getIcon("Due_Date_Days_White")} {item.TotalDays} days
                      </div>
                      <div style={{ fontSize: "13px", fontWeight: 500, color: "#FFFFFF", fontFamily: "Poppins", display: "flex", gap: "4px", alignItems: "center", whiteSpace: "nowrap" }}>
                        {getIcon("GoldBar")}
                        {item["Unfix Weight"] ?? null} g
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </>
        );

      case "ledger":
        return (
          <>
            {/* Static Opening Balance */}
            <div style={{ ...transactionGroupStyle, cursor: "default" }}>
              <div style={{ display: "flex" }}>
                {/* Left Column */}
                <div style={{ flex: 2, display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div
                    style={{
                      fontSize: "8px",
                      fontWeight: 400,
                      color: "#B3B3B3",
                      lineHeight: "100%",
                      fontFamily: "Poppins",
                      width: "fit-content",
                      padding: "3px 8px",
                      background: "#0D0D0D",
                      borderRadius: "3px",
                    }}
                  >
                    Opening Balance
                  </div>
                  <div style={{ fontSize: "12px", color: "#CCCCCC", fontFamily: "Poppins", display: "flex", gap: "6px", alignItems: "center" }}>
                    {getIcon("Grey_Date_Icon")} {getFinancialYearStart()}
                  </div>
                </div>

                {/* Right Column */}
                <div style={{ flex: 1, display: "flex", justifyContent: "end", alignItems: "center" }}>
                  <div style={{ fontSize: "16px", fontWeight: 700, color: data?.summary?.OpeningDebit > 0 ? "#50C878" : "#E77B7B", fontFamily: "Poppins" }}>
                    {formatCurrency(data.summary?.OpeningDebit || data.summary?.OpeningCredit)}
                  </div>
                </div>
              </div>
            </div>

            {/* Regular Transactions */}
            {!data?.items?.length && <TransactionSmallCard count={10} />}
            {data?.items?.map((item, index) => (
              <div
                key={index}
                style={{
                  ...transactionGroupStyle,
                  border: selectedCard?.TransactionNo === item.TransactionNo ? "1px solid #fff" : transactionGroupStyle.border,
                  cursor: "pointer",
                }}
                onClick={() => setSelectedCard(item)}
              >
                <div style={{ display: "flex" }}>
                  {/* Left Column */}
                  <div style={{ flex: 2, display: "flex", flexDirection: "column", gap: "12px" }}>
                    <div style={{ fontSize: "15px", fontWeight: 400, color: "#CCCCCC", lineHeight: "20px", fontFamily: "Karla", whiteSpace: "nowrap" }}>{item.TransactionNo}</div>
                    <div style={{ fontSize: "12px", color: "#CCCCCC", fontFamily: "Poppins", display: "flex", gap: "6px", alignItems: "center" }}>
                      {getIcon("Grey_Date_Icon")} {formatDateWithSuffix(item.TransactionDate)}
                    </div>
                  </div>

                  {/* Right Column */}
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "end", gap: "6px" }}>
                    <Tooltip title={item?.BookName}>
                      <div
                        style={{ fontSize: "14px", fontWeight: 500, color: "#FCFAFA", fontFamily: "Poppins", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "150px" }}
                      >
                        {item.BookName}
                      </div>
                    </Tooltip>
                    <div style={{ fontSize: "16px", fontWeight: 700, color: item.Debit > 0 ? "#50C878" : "#E77B7B", fontFamily: "Poppins", whiteSpace: "nowrap" }}>
                      {formatCurrency(item.Credit || item.Debit)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        );

      case "quote-order":
        return (
          <>
            {/* Individual Items */}
            {(!data?.items?.length || isFetching) && <TransactionSmallCard count={10} />}
            {data?.items?.map((item, index) => (
              <div
                key={index}
                style={{
                  ...transactionGroupStyle,
                  border: selectedCard?.OrderNo === item.OrderNo ? "1px solid #fff" : transactionGroupStyle.border,
                  cursor: "pointer",
                }}
                onClick={() => setSelectedCard(item)}
              >
                <div style={{ display: "flex" }}>
                  {/* Left Column */}
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "12px" }}>
                    <div style={{ fontSize: "15px", fontWeight: 400, color: "#CCCCCC", fontFamily: "Karla" }}>{item.OrderNo}</div>
                    {item.OrderDate !== "All" && (
                      <div style={{ fontSize: "12px", color: "#CCCCCC", fontFamily: "Poppins", fontWeight: 400, lineHeight: "100%", display: "flex", gap: "6px" }}>
                        {getIcon("Grey_Date_Icon")} {formatDateWithSuffix(item.OrderDate)}
                      </div>
                    )}
                  </div>

                  {/* Right Column */}
                  <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px", whiteSpace: "nowrap" }}>
                    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                      <div style={{ fontSize: "14px", fontWeight: 500, color: "#FCFAFA", display: "flex", gap: "4px", alignItems: "center" }}>
                        {getIcon("RedBag")} {item.Bags}
                      </div>
                      {item.DiaWt >= 0 && (
                        <div style={{ fontSize: "14px", fontWeight: 500, color: "#FCFAFA", display: "flex", gap: "4px", alignItems: "center" }}>
                          {getIcon("Small_Diamond")} {item?.DiaWt === 0 ? item?.DiaWt : item.DiaWt?.toFixed(4)} Ct
                        </div>
                      )}
                      {item.NetWt >= 0 && (
                        <div style={{ fontSize: "14px", fontWeight: 500, color: "#FCFAFA", display: "flex", gap: "4px", alignItems: "center" }}>
                          {getIcon("GoldBar")} {item?.NetWt === 0 ? item?.NetWt : item.NetWt?.toFixed(4)} g
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        );

      case "wip":
        return data?.items?.map((item, index) => (
          <div
            key={index}
            style={{
              ...transactionGroupStyle,
              border: selectedCard?.DepartmentCode === item.DepartmentCode ? "1px solid #fff" : transactionGroupStyle.border,
              cursor: "pointer",
            }}
            onClick={() => setSelectedCard(item)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 0",
              }}
            >
              {/* Department Name - Left aligned */}
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: 400,
                  color: "#FFFFFF",
                  fontFamily: "Karla",
                  lineHeight: "20px",
                }}
              >
                {item.DepartmentCode}
              </div>

              {/* Numbers - Right aligned with consistent spacing */}
              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#FCFAFA",
                    fontFamily: "Poppins",
                    lineHeight: "22px",
                    letterSpacing: "-0.41px",
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  {getIcon("RedBag")} {item.BQty}
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#FCFAFA",
                    fontFamily: "Poppins",
                    lineHeight: "22px",
                    letterSpacing: "-0.41px",
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  {getIcon("Small_Diamond")} {item.RequiredDWt} Ct
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#FCFAFA",
                    fontFamily: "Poppins",
                    lineHeight: "22px",
                    letterSpacing: "-0.41px",
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  {getIcon("GoldBar")} {item.RequiredNWt} g
                </div>
              </div>
            </div>
          </div>
        ));

      default:
        return <div>Unknown type</div>;
    }
  };

  return <div style={transactionCardContentStyle}>{renderContent()}</div>;
};

export default ClientInnerCard;
